// extracted by mini-css-extract-plugin
export default {"main":"PracticeReporting_main__nXq6y","title":"PracticeReporting_title__268cv","content":"PracticeReporting_content__tpMw5"};